import React from "react";
import "../../Assets/styles/Details.css";
import scheduleImage from "../../Assets/images/detail-schedule.png";


const DetailsSection = () => {
  return (
    <section className="details-section" id="details">
    <div className="details-grid">

      {/* now goes to bottom right */}
      <div className="details-tile details-tile-agenda">
        <div className="details-overlay-title">
          AGENDA
        </div>
      </div>

      {/* now goes to bottom left */}
      <div className="details-tile details-panel details-panel-timeline details-schedule details-tile-schedule">
        <img
          src={scheduleImage}
          alt="Wedding Schedule"
          className="details-schedule-image"
        />
      </div>

      {/* now goes to top right */}
      <div className="details-tile details-panel details-panel-cream details-tile-venue-info">
        <div className="venue-wrapper">
          <div className="venue-block">
            <div className="venue-title">LOCAL</div>
            <div className="venue-name"></div>
            <div className="venue-title">CERIMÓNIA E FESTA</div>
          </div>

          <div className="venue-divider"></div>

          <div className="venue-block">
            <div className="venue-name">Quinta das Silveiras</div>
            <div className="venue-address">IC2, 2400-822 Leiria</div>
          </div>

          <a
            className="details-btn-dark"
            href="https://maps.app.goo.gl/ZN9wsFbtPba4CBxd8"
            target="_blank"
            rel="noopener noreferrer"
          >
            VER NO MAPS
          </a>
        </div>
      </div>

      {/* now goes to top left */}
      <div className="details-tile details-panel details-panel-dark details-tile-venue-photo">
        <div className="venueDetails-inner">
          <div className="venueDetails-title">
            LOCAL
          </div>
        </div>
      </div>

    </div>
  </section>
  );
};

export default DetailsSection;